import React, {Component} from 'react';
import Attachments from "./Attachments";
import TextEntryRender from './TextEntryRender';
import QuizRender from './QuizRender';
import DiscussionRender from './DiscussionRender'

const SUBMISSION_TYPES = {
    ONLINE_TEXT_ENTRY: "online_text_entry",
    ONLINE_QUIZ: "online_quiz",
    ONLINE_DISCUSSION: "online_discussion"
};

class Submission extends Component {
    showArtifacts() {
        console.log('rendering the submission ', this.props.submission.submission_type);
        let artifact = null;
        if (this.props.submission.attachments && this.props.submission.attachments.length > 0) {
            artifact = (<Attachments submission={this.props.submission} isReviewed={this.props.isReviewed}/>)
        } else {
            switch (this.props.submission.submission_type) {
                case SUBMISSION_TYPES.ONLINE_TEXT_ENTRY:
                    artifact = (<TextEntryRender submission={this.props.submission}  isReviewed={this.props.isReviewed}/>);
                    break;

                case SUBMISSION_TYPES.ONLINE_QUIZ:
                    artifact = (<QuizRender submission={this.props.submission}  isReviewed={this.props.isReviewed}/>);
                    // artifact = (<DiscussionRender/>);
                    break;

                case SUBMISSION_TYPES.ONLINE_DISCUSSION:
                    artifact = (<DiscussionRender submission={this.props.submission}/>);
                    break;

                default:
                    artifact = (<div>Unknown Submission Type</div>);
            }
        }

        return artifact;
    }

    render() {
        return (
            <span>
                {this.showArtifacts()}
            </span>
        )
    }
}


export default Submission;
